// extracted by mini-css-extract-plugin
module.exports = {"container":"zB","productName":"AB","modal":"BB","dimensions":"CB","recipientEmail":"DB","lowStock":"EB","recommendedFit":"FB","notRecommendedFit":"GB"};